/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tickets_Subject_Too_LongInputs */

const nl_tickets_subject_too_long = /** @type {(inputs: Tickets_Subject_Too_LongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het onderwerp mag maximaal 150 tekens bevatten.`)
};

/**

* @param {Tickets_Subject_Too_LongInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const tickets_subject_too_long = /** @type {((inputs?: Tickets_Subject_Too_LongInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tickets_Subject_Too_LongInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_tickets_subject_too_long(inputs)
});
export { tickets_subject_too_long as "tickets.subject_too_long" }